<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Editar Integrante'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
            <v-container>

              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Nome'
                    v-model="integrante.nome"
                    readonly
                    max-height="400"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap justify-space-between>
                <v-flex xs12>
                  <v-text-field
                    label='Vínculo'
                    :value="integrante.vinculo"
                    max-height="400"
                    readonly              
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <v-select
                    label='Função'
                    :items="listaFuncao"
                    v-model="integrante.funcao"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5 v-if="integrante.funcao.item !== 1">
                  <v-select
                    label='Assessor'
                    :items="listaAssessor"
                    v-model="integrante.assessor"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    required
                    :disabled="projeto.assessor === true && administrador === false"
                    autocomplete >
                  </v-select>
                </v-flex>
                <v-flex xs11 sm5 v-if="integrante.funcao.item === 1">
                  <v-text-field
                    label='Assessor'
                    value="-"
                    disabled
                    max-height="400"
                    readonly              
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap justify-space-between v-if="integrante.assessor === true">
                <v-flex xs12>
                  <div class="center">
                    <v-card outlined>
                      <v-card-text class="black--text font-weight-bold">
                        O assessor deve ser um único integrante da equipe e terá apenas a permissão de preenchimento, não sendo autorizado a ele submeter para aprovação, excluir ou finalizar a ação.
                      </v-card-text>
                    </v-card>
                  </div>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <v-text-field
                    label='Carga horária semanal'
                    v-model="integrante.cargaHoraria"
                    prepend-icon="dashboard"
                    :rules="regrasCargaHoraria"
                    :disabled="integrante.funcao.item === 1"
                    max-height="400">
                  </v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5>
                  <v-select
                    label='Escolaridade'
                    :items="listaTitulacao"
                    v-model="integrante.titulacao"
                    item-text="descricao"
                    item-value="item"
                    prepend-icon="dashboard"
                    max-height="400"
                    return-object
                    required
                    autocomplete
                    :rules="regrasBasicas" >
                  </v-select>
                </v-flex>
              </v-layout>

              <p class="mt-1"></p>

              <v-layout row wrap>
                <v-flex xs11 sm5>
                  <c-date-menu label="Data inicial" v-model="integrante.dataInicial" required :rules="regrasBasicas"></c-date-menu>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs11 sm5 v-if="this.integrante.situacao !== 'A'">
                  <c-date-menu label="Data final" v-model="integrante.dataFinal" clearable></c-date-menu>
                </v-flex>
              </v-layout>

              <!-- Instituição que o membro da equipe representa -->
              <v-layout row wrap justify-space-between v-if="(integrante.vinculo === 'Externo' || integrante.vinculo === 'Aluno de pós-graduação')">
                <v-flex>
                  <v-text-field
                    label='Instituição que o membro da equipe representa'
                    v-model="integrante.instituicao"
                    counter="100"
                    :rules="regrasInstituicao"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <p class="mt-1" v-if="integrante.alunoPosUfes === 'N'"></p>

              <v-layout row wrap justify-space-between>
                <v-flex>
                  <c-textarea :rows="2" :auto-grow="true"
                  label="Observação" v-model="integrante.obsParticipante"></c-textarea>
                </v-flex>
              </v-layout>

            </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editarIntegrante" :disabled="!formularioValido || (integrante.alunoPosUfes === 'N' && integrante.instituicao === null)">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto', 'idParticipante'],
    data: () => ({
      formularioValido: false,
      projeto: {},
      integrante: {
        nome: '',
        dataInicial: '',
        dataFinal: '',
        funcao: {},
        titulacao: {},
        ativo: true,
        cargaHoraria: 0,
        obsParticipante: ''
      },
      listaFuncao: [],
      listaTitulacao: [],
      listaAssessor: [
        { 'item': true, 'descricao': 'Sim' },
        { 'item': false, 'descricao': 'Não' }
      ],
      regrasCargaHoraria: [
        (input) => input !== undefined && input !== null && input !== '' || 'Este campo é obrigatório',
        (input) => !isNaN(input) || 'A carga horária deve ser numérica',
        (input) => (input.length === 0 || Number(input) >= 0) || 'A carga horária não pode ser negativa'
      ],
      regrasInstituicao: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => input.length <= 100 || 'Este campo não pode possuir mais que 100 caracteres'
      ],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      editarIntegrante: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' })

        // Limpa campo caso a opção "Aluno de Pós-Graduação da Ufes" seja "Sim".
        if (this.integrante.alunoPosUfes === 'S') {
          this.integrante.instituicao = null
        }

        let aux = JSON.parse(JSON.stringify(this.integrante))
        aux.idParticipante = undefined
        aux.idPessoa = undefined
        aux.nome = undefined
        aux.vinculo = undefined
        projetos.putIntegrante(this.idProjeto, this.idParticipante, aux)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'IntegrantesProjeto', params: {idProjeto: this.idProjeto}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando integrante.' })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      }
    },
    mounted () {
      this.opcoesTabelaEstruturada(6003, this, 'listaFuncao')
      this.opcoesTabelaEstruturada(168, this, 'listaTitulacao')

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
      projetos.getIntegrante(this.idProjeto, this.idParticipante)
      .then(response => {
        this.integrante = response.data

        // Quando o integrante é o coordenador.
        if (response.data.funcao.item === 1) {
          this.listaFuncao.splice(0, 1) // Remove a função "Bolsista-PROEX".
          this.listaFuncao.splice(1, 3) // Remove as funções "Discente-coordenador", "Integrante" e "Subcoordenador".
        }

        // Quando o integrante não é o coordenador.
        if (response.data.funcao.item !== 1) {
          this.listaFuncao.splice(1, 1) // Remove a função "Coordenador".
        }
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .center {
    text-align: center;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-integrante.vue?b8c5ad16